module.exports = __webpack_public_path__ + "static/img/talk_circle.112c39a0.png";